import React, { useState } from "react";
import { Button, Toast, ToastBody, ToastHeader } from "reactstrap";

export const useBSToasts = (initialState, timeout = 5000) => {
    const [errors, setErrors] = useState(initialState || []);
    const popError = (idToRemove, callback) => {
        const newErrors = [...errors.filter(err => err.id !== idToRemove)];
        setErrors(newErrors && newErrors.length ? newErrors : (initialState || []));

        if (callback && typeof callback === 'function') {
            callback();
        }
    };

    return [
        <div className="toast-container position-fixed bottom-0 end-0 p-3" style={{ zIndex: 11 }}>
            {errors && errors.map(err => {
                let border = '';
                let background = '';
                let level = '';
                let fontColor = '';
                if (err.appearance) {
                    level = err.appearance;

                    switch (err.appearance) {
                        case 'error':
                            level = 'danger';
                        case 'secondary':
                        case 'primary':
                        case 'success':
                            fontColor = 'white';
                            break;
                        default:
                    }

                    if (level) {
                        border = `border-${level}`;
                        background = `bg-${level}`;
                    }
                }

                return (<Toast key={err.id} className={`${border}`}>
                    <ToastHeader className={`${background} text-${fontColor}`} close={err.autoDismiss ? null : <Button color="close" className={`btn-close-${fontColor}`} onClick={() => popError(err.id)}></Button>}>{err.header || ''}</ToastHeader>
                    <ToastBody>
                        {err.msg}
                    </ToastBody>
                </Toast>);
            })}
        </div>,
        (msg, newErrorConfig) => {
            const id = Math.random();

            if (newErrorConfig) {
                if (!newErrorConfig.id) {
                    newErrorConfig.id = id;
                }

                if (newErrorConfig.autoDismiss) {
                    setTimeout(() => popError(newErrorConfig.id), timeout);
                }
            }

            const newErrors = [...errors, { msg, ...newErrorConfig }];

            setErrors(newErrors);
        },
        popError
    ]
};


// WEBPACK FOOTER //
// ./src/components/Shared/BSToasts.js